import type { ReactNode } from "react";
import U2000RequireRole from "../u2000Core/components/controls/U2000RequireRole";
import U3130, { U3130ROLES } from "./U3130";
import U3130TimesheetList from "./components/list/U3130TimesheetList";
import U3130TimesheetDetail from "./components/form/U3130TimesheetDetail";

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3130Routes: RouteObject[] = [
  {
    path: "U3130",
    element: <U2000RequireRole allowedRoles={[U3130ROLES.READ]} />,
    children: [
      {
        path: "",
        element: <U3130 />,
        children: [
          { index: true, element: <U3130TimesheetList /> },
          { path: ":id", element: <U3130TimesheetDetail /> },
        ],
      },
    ],
  },
];

export default U3130Routes;
